import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { WallFolderWithRelations } from 'types';

export const getFolders = async (
  userId: number | undefined
): Promise<WallFolderWithRelations[]> => {
  if (userId === undefined) return [];
  const { data } = await axios.get(`/api/users/${userId}/folders`);
  return data as WallFolderWithRelations[];
};

type QueryFnType = typeof getFolders;

type UseFoldersOptions = {
  userId: number | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useFolders = ({ userId, config }: UseFoldersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['folders', userId],
    queryFn: () => getFolders(userId),
  });
};
